/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react'
import PropTypes from 'prop-types'
import ImageThumb from '../ImageThumb'

function AttachmentPreview({ src, size }) {
  const extension = src.split('.').pop()?.toLowerCase()

  if (extension === 'pdf') {
    return (
      <a
        href={src}
        target="_blank"
        rel="noreferrer"
        className="s-rounded bg-dark flex-centered"
        style={{
          width: size, height: size, display: 'inline-flex', color: '#fff',
        }}
      >
        <i className="far fa-file-pdf" />
      </a>
    )
  }

  return (
    <a href={src} target="_blank" rel="noreferrer">
      <ImageThumb className="s-rounded" src={src} width={size} height={size} />
    </a>
  )
}

AttachmentPreview.propTypes = {
  src: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
}

export default AttachmentPreview
